<template>
  <UIModal v-model="isOpen" fix-header>
    <div
      class="tw:absolute tw:top-2 tw:sm:-top-20 tw:left-1/2 tw:-translate-x-1/2 tw:z-1 tw:w-[min(400px,calc(100vw-32px))] tw:sm:w-md"
    >
      <img src="/img/v2-migration-banner.png" alt="" class="tw:block tw:w-full tw:h-auto" />
      <span
        class="tw:absolute tw:top-1/2 tw:left-1/2 tw:-translate-x-1/2 tw:-translate-y-[calc(50%+6px)] tw:whitespace-nowrap tw:z-2 tw:font-bold tw:text-2xl tw:sm:text-[32px] tw:leading-none tw:text-white v2-migration-banner-text"
      >
        {{ $t('v2MigrationBanner') }}
      </span>
    </div>
    <div
      class="tw:min-h-full tw:flex tw:flex-col tw:justify-center tw:sm:block tw:relative tw:w-full tw:max-w-xl tw:pt-[50px] tw:sm:pt-0"
    >
      <!-- TODO: replace placeholder with final hero image (designer) -->
      <img
        src="/img/v2-migration-hero.png"
        alt=""
        class="tw:w-full tw:aspect-[16/9] tw:object-cover tw:bg-neutral-900 tw:rounded-none tw:sm:rounded-t-xl"
      />
      <div
        class="tw:mt-4 tw:font-bold tw:text-2xl tw:sm:text-[28px] tw:leading-none tw:text-center tw:mx-auto tw:max-w-[310px] tw:sm:max-w-none v2-migration-title"
      >
        {{ $t('v2MigrationTitle') }}
      </div>
      <div
        class="tw:mx-5 tw:mt-2 tw:mb-4 tw:sm:mx-10 tw:sm:mt-4 tw:sm:mb-6 tw:text-base tw:leading-snug tw:text-center tw:text-white"
      >
        {{ $t('v2MigrationDescription') }}
      </div>
      <div
        class="tw:mx-4 tw:mb-4 tw:sm:mx-6 tw:sm:mb-6 tw:flex tw:flex-wrap tw:items-center tw:justify-center tw:gap-2 tw:sm:gap-3"
      >
        <span class="tw:font-bold tw:text-sm tw:sm:text-base tw:text-white">{{ $t('v2MigrationCountdownLabel') }}</span>
        <span
          class="tw:font-bold tw:text-sm tw:sm:text-base tw:text-white tw:px-3 tw:py-1 tw:sm:px-4 tw:sm:py-[6px] tw:rounded-full tw:border-2 tw:border-[#FFC800] tw:whitespace-nowrap"
        >
          {{ countdownText }}
        </span>
      </div>
      <div class="tw:mb-10 tw:flex tw:items-center tw:justify-center">
        <button class="btn-primary tw:w-fit!" @click="handleGoToV2">{{ $t('v2MigrationCta') }}</button>
      </div>
    </div>
  </UIModal>
</template>

<script lang="ts" setup>
import useCountdownDate from '~/composables/useCountdownDate';

const props = defineProps<{
  shutdownDate: Date;
  v2GameUrl: string;
}>();

const isOpen = defineModel<boolean>({ default: false });
const { t } = useI18n();

const shutdownDateRef = computed(() => props.shutdownDate);
const { timeLeft, clearCountdown } = useCountdownDate(shutdownDateRef, 'second');

// useCountdownDate registers its interval on mount but has no built-in teardown,
// so explicitly stop it when this modal unmounts (v-if-driven, see app.vue).
onBeforeUnmount(() => clearCountdown());

const countdownText = computed(
  () =>
    `${timeLeft.days}${t('v2MigrationDaysShort')} ${timeLeft.hours}${t('v2MigrationHoursShort')} ${timeLeft.minutes}${t('v2MigrationMinutesShort')}`
);

const handleGoToV2 = () => {
  if (!props.v2GameUrl) return;
  // Close + mark-as-shown before the redirect so a bfcache-restored back-button
  // landing doesn't re-pop the same popup.
  isOpen.value = false;
  window.location.href = props.v2GameUrl;
};
</script>

<style scoped>
/* Effects Tailwind can't express ergonomically: layered text-shadow stroke and gradient text fill. */
.v2-migration-banner-text {
  text-shadow:
    1px 1px 0 #000,
    -1px -1px 0 #000,
    1px -1px 0 #000,
    -1px 1px 0 #000,
    0 1px 0 #000,
    0 -1px 0 #000,
    1px 0 0 #000,
    -1px 0 0 #000;
  filter: drop-shadow(0 2px 0 #000);
}

.v2-migration-title {
  background: linear-gradient(180deg, #ffee33 26.91%, #ffc800 43.13%, #fff15d 66.15%, #ffc800 97.02%, #fff15d 135.74%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  filter: drop-shadow(1px 1px 0 #ff6100) drop-shadow(-1px -1px 0 #ff6100) drop-shadow(1px -1px 0 #ff6100)
    drop-shadow(-1px 1px 0 #ff6100);
}
</style>
